import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { Helmet } from 'react-helmet-async'
import { CartBasic } from './components/CartBasic/CartBasic'
import { DialogSelectProductVariation } from './components/DialogSelectProductVariation/DialogSelectProductVariation'

const styles = stylex.create({
  root: {
    backgroundColor: colors.grey100,
    minHeight: '100vh',
    paddingBottom: 148,
  },
})

export const Cart = () => {
  return (
    <div {...stylex.props(styles.root)}>
      <Helmet>
        <title>購物車</title>
      </Helmet>
      <CartBasic />
      <DialogSelectProductVariation />
    </div>
  )
}
